import ValueMode from './ValueMode';
export default ValueMode;